package id.neotica.neotica.pages.legal

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initPrivacyPolicyPage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("legal/PrivacyPolicy.md", FrontMatterElement.Builder { addScalar("title", "Privacy Policy"); }))
}

@Page("/legal/privacy-policy")
@Layout(".components.layouts.MarkdownLayout")
@Composable
fun PrivacyPolicyPage() {
    org.jetbrains.compose.web.dom.H2(attrs = { id("privacy-policy") }) {
        org.jetbrains.compose.web.dom.Text("Privacy Policy")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Last updated: October 04, 2024")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("This Privacy Policy describes Our policies and procedures on the collection, use and disclosure of Your information when You use the Service and tells You about Your privacy rights and how the law protects You.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("We use Your Personal data to provide and improve the Service. By using the Service, You agree to the collection and use of information in accordance with this Privacy Policy.")
    }
    com.varabyte.kobweb.silk.components.layout.HorizontalDivider()
    org.jetbrains.compose.web.dom.H3(attrs = { id("interpretation-and-definitions") }) {
        org.jetbrains.compose.web.dom.Text("Interpretation and Definitions")
    }
    org.jetbrains.compose.web.dom.H4(attrs = { id("interpretation") }) {
        org.jetbrains.compose.web.dom.Text("Interpretation")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The words of which the initial letter is capitalized have meanings defined under the following conditions. The following definitions shall have the same meaning regardless of whether they appear in singular or in plural.")
    }
    org.jetbrains.compose.web.dom.H4(attrs = { id("definitions") }) {
        org.jetbrains.compose.web.dom.Text("Definitions")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("For the purposes of this Privacy Policy:")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Account means a unique account created for You to access our Service or parts of our Service.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Affiliate means an entity that controls, is controlled by or is under common control with a party, where \"control\" means ownership of 50% or more of the shares, equity interest or other securities entitled to vote for election of directors or other managing authority.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Application refers to Neoverse, the software program provided by the Company. This includes any entities under the package “id.neotica.neoverse”")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Company (referred to as either \"the Company\", \"We\", \"Us\" or \"Our\" in this Agreement) refers to PT Neotica Digital Solusi, Bandar Lampung, Lampung, Indonesia.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Country refers to: Indonesia")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Device means any device that can access the Service such as a computer, a cellphone or a digital tablet.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Personal Data is any information that relates to an identified or identifiable individual.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Service refers to the features under the Application.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Service Provider means any natural or legal person who processes the data on behalf of the Company. It refers to third-party companies or individuals employed by the Company to facilitate the Service, to provide the Service on behalf of the Company, to perform services related to the Service or to assist the Company in analyzing how the Service is used.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Third-party Social Media Service refers to any website or any social network website through which a User can log in or create an account to use the Service.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Usage Data refers to data collected automatically, either generated by the use of the Service or from the Service infrastructure itself (for example, the duration of a page visit).")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("You means the individual accessing or using the Service, or the company, or other legal entity on behalf of which such individual is accessing or using the Service, as applicable.")
        }
    }
    org.jetbrains.compose.web.dom.H3(attrs = { id("collecting-and-using-your-personal-data") }) {
        org.jetbrains.compose.web.dom.Text("Collecting and Using Your Personal Data")
    }
    org.jetbrains.compose.web.dom.H4(attrs = { id("types-of-data-collected") }) {
        org.jetbrains.compose.web.dom.Text("Types of Data Collected")
    }
    org.jetbrains.compose.web.dom.H5(attrs = { id("personal-data") }) {
        org.jetbrains.compose.web.dom.Text("Personal Data")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("While using Our Service, We may ask You to provide Us with certain personally identifiable information that can be used to contact or identify You. Personally identifiable information may include, but is not limited to:")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Email address")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("First name and last name")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Usage Data")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("App Data")
        }
    }
    org.jetbrains.compose.web.dom.H5(attrs = { id("usage-data") }) {
        org.jetbrains.compose.web.dom.Text("Usage Data")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Usage Data is collected automatically when using the Service.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Usage Data may include information such as Your Device's Internet Protocol address (e.g. IP address), browser type, browser version, the pages of our Service that You visit, the time and date of Your visit, the time spent on those pages, unique device identifiers and other diagnostic data.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("When You access the Service by or through a mobile device, We may collect certain information automatically, including, but not limited to, the type of mobile device You use, Your mobile device unique ID, the IP address of Your mobile device, Your mobile operating system, the type of mobile Internet browser You use, unique device identifiers and other diagnostic data.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("We may also collect information that Your browser sends whenever You visit our Service or when You access the Service by or through a mobile device.")
    }
    org.jetbrains.compose.web.dom.H5(attrs = { id("information-from-third-party-social-media-services") }) {
        org.jetbrains.compose.web.dom.Text("Information from Third-Party Social Media Services")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The Company allows You to create an account and log in to use the Service through the following Third-party Social Media Services:")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Google")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Instagram")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("LinkedIn")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("If You decide to register through or otherwise grant us access to a Third-Party Social Media Service, We may collect Personal data that is already associated with Your Third-Party Social Media Service's account, such as Your name, Your email address, Your activities or Your contact list associated with that account.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("You may also have the option of sharing additional information with the Company through Your Third-Party Social Media Service's account. If You choose to provide such information and Personal Data, during registration or otherwise, You are giving the Company permission to use, share, and store it in a manner consistent with this Privacy Policy.")
    }
    org.jetbrains.compose.web.dom.H5(attrs = { id("information-collected-while-using-the-application") }) {
        org.jetbrains.compose.web.dom.Text("Information Collected while Using the Application")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("While using Our Application, in order to provide features of Our Application, We may collect, with Your prior permission:")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Pictures and other information from your Device's camera and photo library We use this information to provide features of Our Service, to improve and customize Our Service. The information may be uploaded to the Company's servers and/or a Service Provider's server or it may be simply stored on Your device.")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("You can enable or disable access to this information at any time, through Your Device settings. For the case of Usage data, you can appropriately Delete your account to delete all your Usage data from our services.")
    }
    org.jetbrains.compose.web.dom.H4(attrs = { id("use-of-your-personal-data") }) {
        org.jetbrains.compose.web.dom.Text("Use of Your Personal Data")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The Company may use Personal Data for the following purposes:")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("To provide and maintain our Service, including to monitor the usage of our Service.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("To manage Your Account: to manage Your registration as a user of the Service. The Personal Data You provide can give You access to different functionalities of the Service that are available to You as a registered user.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("For the performance of a contract: the development, compliance and undertaking of the purchase contract for the products, items or services You have purchased or of any other contract with Us through the Service.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("To contact You: To contact You by email, telephone calls, SMS, or other equivalent forms of electronic communication, such as a mobile application's push notifications regarding updates or informative communications related to the functionalities, products or contracted services, including the security updates, when necessary or reasonable for their implementation.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("To provide You with news, special offers and general information about other goods, services and events which we offer that are similar to those that you have already purchased or enquired about unless You have opted not to receive such information.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("To manage Your requests: To attend and manage Your requests to Us.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("For business transfers: We may use Your information to evaluate or conduct a merger, divestiture, restructuring, reorganization, dissolution, or other sale or transfer of some or all of Our assets, whether as a going concern or as part of bankruptcy, liquidation, or similar proceeding, in which Personal Data held by Us about our Service users is among the assets transferred.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("For other purposes: We may use Your information for other purposes, such as data analysis, identifying usage trends, determining the effectiveness of our promotional campaigns and to evaluate and improve our Service, products, services, marketing and your experience.")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("We may share Your personal information in the following situations:")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("With Service Providers: We may share Your personal information with Service Providers to monitor and analyze the use of our Service, to contact You.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("For business transfers: We may share or transfer Your personal information in connection with, or during negotiations of, any merger, sale of Company assets, financing, or acquisition of all or a portion of Our business to another company.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("With Affiliates: We may share Your information with Our affiliates, in which case we will require those affiliates to honor this Privacy Policy. Affiliates include Our parent company and any other subsidiaries, joint venture partners or other companies that We control or that are under common control with Us.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("With business partners: We may share Your information with Our business partners to offer You certain products, services or promotions.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("With other users: when You share personal information or otherwise interact in the public areas with other users, such information may be viewed by all users and may be publicly distributed outside. If You interact with other users or register through a Third-Party Social Media Service, Your contacts on the Third-Party Social Media Service may see Your name, profile, pictures and description of Your activity. Similarly, other users will be able to view descriptions of Your activity, communicate with You and view Your profile.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("With Your consent: We may disclose Your personal information for any other purpose with Your consent.")
        }
    }
    org.jetbrains.compose.web.dom.H4(attrs = { id("retention-of-your-personal-data") }) {
        org.jetbrains.compose.web.dom.Text("Retention of Your Personal Data")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The Company will retain Your Personal Data only for as long as is necessary for the purposes set out in this Privacy Policy. We will retain and use Your Personal Data to the extent necessary to comply with our legal obligations (for example, if we are required to retain your data to comply with applicable laws), resolve disputes, and enforce our legal agreements and policies.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The Company will also retain Usage Data for internal analysis purposes. Usage Data is generally retained for a shorter period of time, except when this data is used to strengthen the security or to improve the functionality of Our Service, or We are legally obligated to retain this data for longer time periods.")
    }
    org.jetbrains.compose.web.dom.H4(attrs = { id("transfer-of-your-personal-data") }) {
        org.jetbrains.compose.web.dom.Text("Transfer of Your Personal Data")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Your information, including Personal Data, is processed at the Company's operating offices and in any other places where the parties involved in the processing are located. It means that this information may be transferred to — and maintained on — computers located outside of Your state, province, country or other governmental jurisdiction where the data protection laws may differ than those from Your jurisdiction.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Your consent to this Privacy Policy followed by Your submission of such information represents Your agreement to that transfer.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The Company will take all steps reasonably necessary to ensure that Your data is treated securely and in accordance with this Privacy Policy and no transfer of Your Personal Data will take place to an organization or a country unless there are adequate controls in place including the security of Your data and other personal information.")
    }
    org.jetbrains.compose.web.dom.H4(attrs = { id("delete-your-personal-data") }) {
        org.jetbrains.compose.web.dom.Text("Delete Your Personal Data")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("You have the right to delete or request that We assist in deleting the Personal Data that We have collected about You.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Our Service may give You the ability to delete certain information about You from within the Service.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("You may update, amend, or delete Your information at any time by signing in to Your Account, if you have one, and visiting the account settings section that allows you to manage Your personal information. You may also contact Us to request access to, correct, or delete any personal information that You have provided to Us.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Please note, however, that We may need to retain certain information when we have a legal obligation or lawful basis to do so.")
    }
    org.jetbrains.compose.web.dom.H4(attrs = { id("disclosure-of-your-personal-data") }) {
        org.jetbrains.compose.web.dom.Text("Disclosure of Your Personal Data")
    }
    org.jetbrains.compose.web.dom.H5(attrs = { id("business-transactions") }) {
        org.jetbrains.compose.web.dom.Text("Business Transactions")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("If the Company is involved in a merger, acquisition or asset sale, Your Personal Data may be transferred. We will provide notice before Your Personal Data is transferred and becomes subject to a different Privacy Policy.")
    }
    org.jetbrains.compose.web.dom.H5(attrs = { id("law-enforcement") }) {
        org.jetbrains.compose.web.dom.Text("Law enforcement")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Under certain circumstances, the Company may be required to disclose Your Personal Data if required to do so by law or in response to valid requests by public authorities (e.g. a court or a government agency).")
    }
    org.jetbrains.compose.web.dom.H5(attrs = { id("other-legal-requirements") }) {
        org.jetbrains.compose.web.dom.Text("Other legal requirements")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The Company may disclose Your Personal Data in the good faith belief that such action is necessary to:")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Comply with a legal obligation")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Protect and defend the rights or property of the Company")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Prevent or investigate possible wrongdoing in connection with the Service")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Protect the personal safety of Users of the Service or the public")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Protect against legal liability")
        }
    }
    org.jetbrains.compose.web.dom.H4(attrs = { id("security-of-your-personal-data") }) {
        org.jetbrains.compose.web.dom.Text("Security of Your Personal Data")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The security of Your Personal Data is important to Us, but remember that no method of transmission over the Internet, or method of electronic storage is 100% secure. While We strive to use commercially acceptable means to protect Your Personal Data, We cannot guarantee its absolute security.")
    }
    org.jetbrains.compose.web.dom.H4(attrs = { id("children-s-privacy") }) {
        org.jetbrains.compose.web.dom.Text("Children's Privacy")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Our Service does not address anyone under the age of 13. We do not knowingly collect personally identifiable information from anyone under the age of 13. If You are a parent or guardian and You are aware that Your child has provided Us with Personal Data, please contact Us. If We become aware that We have collected Personal Data from anyone under the age of 13 without verification of parental consent, We take steps to remove that information from Our servers.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("If We need to rely on consent as a legal basis for processing Your information and Your country requires consent from a parent, We may require Your parent's consent before We collect and use that information.")
    }
    org.jetbrains.compose.web.dom.H4(attrs = { id("links-to-other-websites") }) {
        org.jetbrains.compose.web.dom.Text("Links to Other Websites")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Our Service may contain links to other websites that are not operated by Us. If You click on a third party link, You will be directed to that third party's site. We strongly advise You to review the Privacy Policy of every site You visit.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("We have no control over and assume no responsibility for the content, privacy policies or practices of any third party sites or services.")
    }
    org.jetbrains.compose.web.dom.H4(attrs = { id("changes-to-this-privacy-policy") }) {
        org.jetbrains.compose.web.dom.Text("Changes to this Privacy Policy")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("We may update Our Privacy Policy from time to time. We will notify You of any changes by posting the new Privacy Policy on this page.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("We will let You know via email and/or a prominent notice on Our Service, prior to the change becoming effective and update the \"Last updated\" date at the top of this Privacy Policy.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("You are advised to review this Privacy Policy periodically for any changes. Changes to this Privacy Policy are effective when they are posted on this page.")
    }
}
